<!--SKU编辑  -->
<template>
	<div>
		<el-dialog
			title="车辆信息"
			width="600px"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:before-close="cancle">
			<div class="form-box">
				<el-form label-position="top" size="small" :model="dataForm" :rules="rules" ref="dataForm">
					<el-form-item label="组织部门" prop="groupId">
						<div class="flex">
							<el-input v-model.trim="groupName" readonly :disabled="dataForm.carId?true:false"></el-input>
							<el-button type="primary" size="small" class="ml20" @click="showGroupTree" :disabled="dataForm.carId?true:false">配置组织</el-button>
						</div>
					</el-form-item>
					<el-divider></el-divider>
					<div class="flex flex-between">
						<el-form-item class="flex" label="车牌号" prop="licensePlate" label-width="100px">
							<el-input class="ml10 w190" v-model.trim="dataForm.licensePlate" maxlength="10"></el-input>
						</el-form-item>
						<el-form-item class="flex" label="名称" prop="carName" label-width="100px">
							<el-input class="ml10 w190" v-model.trim="dataForm.carName" maxlength="20"></el-input>
						</el-form-item>
					</div>
					<el-form-item class="flex" label="ETC编码" prop="etcCode" label-width="100px">
						<el-input class="ml10 width100" v-model.trim="dataForm.etcCode" maxlength="30"></el-input>
					</el-form-item>
					<el-form-item class="flex" label="备注" prop="remark">
						<el-input class="ml35 width100" v-model.trim="dataForm.remark" type="textarea" :rows="2" maxlength="100"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button  size="small" @click="cancle()">取 消</el-button>
				<el-button  size="small" type="primary" @click="submitForm('dataForm')">确 定</el-button>
			</span>
			<el-dialog
				:visible.sync="groupTreeDialog"
				:close-on-click-modal="false"
				:close-on-press-escape="false"
				append-to-body
				width="35%">
				<div class="dialog-input flex flex-middle" slot="title">
					<label class="f14 font-weight-bold mr5">选择组织部门</label>
				</div>
				<div class="mt10">
					<el-input size="small" placeholder="输入搜索内容" v-model="filterText" clearable></el-input>
				</div>
				<el-tree
					ref="tree"
					:data="treeData"
					show-checkbox
					node-key="groupId"
					:check-strictly="true"
					:props="defaultProps"
					:filter-node-method="filterNode"
					:default-expanded-keys="expandedKeys"
					@check="handleCheck"
					class="tree-box mt10">
					<span class="custom-tree-node" slot-scope="{ node, data }">
						<span>
							<i class="el-icon-folder-opened"></i>
							{{ node.label }}
						</span>
					</span>
				</el-tree>
				<div class="flex flex-center mt20">
					<el-button class="save-btn" type="primary" @click="handleTree()">确定</el-button>
				</div>
			</el-dialog>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dialogVisible: false,
				groupTreeDialog: false,
				treeData: [],
				dataForm: {
					groupId: '',
					licensePlate: '',
					carName: '',
					etcCode: '',
					remark: '',
				},
				rules: {
					carName: [
						{
							required: true,
							message: '请输入名称',
							trigger: 'blur'
						},
					],
					licensePlate: [
						{
							required: true,
							message: '请输入车牌号',
							trigger: 'blur'
						},
						{
							pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]{1,10}?$/,
							message: '请输入10位以内汉字、英文、数字',
						},
					],
					etcCode:[{
							pattern: /^[a-zA-Z0-9]{1,30}?$/,
							message: '请输入30位以内英文、数字',
						},],
					groupId: [
						{
							required: true,
							message: '请选择一个组织',
							trigger: 'blur'
						}
					]
				},
				expandedKeys: [],
				groupName: '',
				filterText: '',
				defaultProps: {
					children: "children",
					label: "groupName"
				}
			}
		},
		created() {

		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
		methods: {
			init(dt) {
				this.dialogVisible = true;
				this.$nextTick(() => {
					this.$refs.dataForm.resetFields();
					this.getTree();
					delete this.dataForm.carId;
					this.groupName = '';
					this.expandedKeys = [];
					this.dataForm.groupId = '';
					if(dt) {
						this.dataForm.carId = dt.carId;
						this.groupName = dt.groupName;
						this.dataForm.groupId = dt.groupId;
						this.dataForm.licensePlate = dt.licensePlate;
						this.dataForm.carName = dt.carName;
						this.dataForm.etcCode = dt.etcCode;
						this.dataForm.remark = dt.remark;
					}
				})
			},
			// 组织树
			showGroupTree() {
				this.groupTreeDialog = true;
				this.$nextTick(() => {
					if(this.dataForm.carId) {
						this.expandedKeys = [this.dataForm.groupId];
						this.$refs.tree.setCheckedKeys([this.dataForm.groupId]);
					}else{
						this.$refs.tree.setCheckedKeys([]);
					}
				})
			},
			// 获取组织
			getTree() {
				let that = this;
				that.$request.post(
					"tree",
					false, {
						groupType: 1
					}
				)
				.then((res) => {
					if (res) {
						that.treeData = res.data;
					}
				})
			},
			// 搜索
			filterNode(value, data) {
				if (!value) return true;
				return data.groupName.indexOf(value) !== -1;
			},
			// 单选
			handleCheck(node,nodes) {
				this.$refs.tree.setCheckedKeys([]);
				if(nodes.checkedKeys.length != 0) {
					this.$refs.tree.setCheckedKeys([node.groupId]);
				}
			},
			// 获取组织部门数据
			handleTree() {
				let node = this.$refs.tree.getCheckedNodes()[0];
				this.dataForm.groupId = node.groupId;
				this.groupName = node.groupName;
				this.groupTreeDialog = false;
			},
			// 保存
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$confirm('是否确认保存？', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
						}).then(() => {
						let that = this;
						that.$request.post(
							that.dataForm.carId ? 'updateCarInfo' : 'addCarInfo',
							true,
							that.dataForm
						)
						.then((res) => {
							if (res) {
								that.dialogVisible = false;
								that.$message.success("保存成功");
								that.$emit("handleSerch");
							}
						})
						}).catch(() => {});
					} else {
						return false;
					}
				});
			},
			// 取消
			cancle() {
				this.dialogVisible = false;
				this.$refs['dataForm'].resetFields();
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.width100 {
		width: 495px;
	}
	.el-tree{
		height: 335px;
    	overflow: auto;
	}
</style>
